import { LiberroButtonWidthType } from 'src/shared/liberro-button/liberro-button.component';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardRoute } from 'src/models/routes.model';

@Component({
  selector: 'liberro-box-consultant',
  standalone: false,
  templateUrl: './liberro-box-consultant.component.html',
  styleUrl: './liberro-box-consultant.component.less'
})
export class LiberroBoxConsultantComponent {
  @Input() public name: string = ''
  @Input() public photoUrl: string | null = null;
  @Input() public email: string = '';
  @Input() public phone: string = '';
  @Input() public heading?: string;
  @Input() public description?: string;
  @Input() public ctaLabel?: string;
  @Input() public whiteVariant = false;
  @Input() public loadingInfo = false;
  @Input() public collaboratorInfoError = false;
  @Input() public clientNotLinkedToCollaborator = false;
  @Output() public requestConsultation = new EventEmitter<void>();

  private router = inject(Router);

  public get wantConsulationWidthType(): LiberroButtonWidthType {
    return this.whiteVariant ? 'width-100' : 'responsive';
  }

  public onBtnConsultation(): void {
    this.requestConsultation.emit();
  }

  public navigateToHome(): void {
    this.router.navigate([`/${DashboardRoute.DASHBOARD}`]);
  }
}

